import React, { useEffect, useState } from "react"
import { connect } from "react-redux";
import {
  Row,
  Col,
} from "reactstrap"

// Pages Components

import TotalDashboardStatistics from "./DashboardStatistics"
import CashierDasboardStatistics from "./CashierDashboardStatistics"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

const Dashboard = (props) => {

  document.title = "Dashboard | Lexa - Responsive Bootstrap 5 Admin Dashboard";


  const breadcrumbItems = [
    { title: "Payment Portal", link: "#" },
    { title: "Dashboard", link: "#" }

  ]

  const [user, setUser] = useState();


  useEffect(() => {
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    setUser(authUser)
    console.log(authUser)
  }, [])

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard', breadcrumbItems)
  },)


  return (
    <React.Fragment>

      <Row>
        {
          (user && (user.role === "developer" || user.role === "accounts")) && (
            <Col xl="12">
              <TotalDashboardStatistics />
            </Col>
          )
        }
        {
          (user && (user.role === "cashier")) && (
            <Col xl="12">
              <CashierDasboardStatistics />
            </Col>
          )
        }


        <Col xl="3">
          {/* <MonthlyEarnings2 /> */}
        </Col>

      </Row>
      <Row>

        <Col xl="4" lg="6">
          {/* inbox */}
          {/* <Inbox /> */}
        </Col>
        <Col xl="4" lg="6">
          {/* recent activity */}
          {/* <RecentActivity /> */}

        </Col>
        <Col xl="4">
          {/* widget user */}
          {/* <WidgetUser /> */}

          {/* yearly sales */}
          {/* <YearlySales /> */}
        </Col>
      </Row>

      <Row>
        <Col xl="6">
          {/* latest transactions */}
          {/* <LatestTransactions /> */}
        </Col>

        <Col xl="6">
          {/* latest orders */}
          {/* <LatestOrders /> */}
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);
